/* Kruikenland: foto volgt de gekozen kleur + keuze 1 of 2 kruiken */
(function () {
  function fileOf(src) { return (src || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, ''); }
  function productJson(root) {
    var el = root && root.querySelector('[data-product-json]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function showVariantImage(root) {
    var product = productJson(root);
    var idInput = root.querySelector('input[name="id"]');
    if (!product || !idInput) return;
    var variant = product.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
    if (!variant || !variant.featured_media) return;
    var gal = document.querySelector('.pz-gal');
    if (!gal) return;
    var slides = gal.querySelectorAll('.pz-gal__slide');
    var thumbs = gal.querySelectorAll('[data-pz-gt]');
    var want = fileOf(variant.featured_media.preview_image && variant.featured_media.preview_image.src);
    var idx = -1;
    Array.prototype.some.call(slides, function (s, i) {
      var img = s.querySelector('img');
      if (img && want && fileOf(img.getAttribute('src')) === want) { idx = i; return true; }
      return false;
    });
    if (idx < 0 && variant.featured_media.position) idx = variant.featured_media.position - 1;
    if (idx >= 0 && thumbs[idx]) thumbs[idx].click();
  }
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('[data-option-group]')) return;
    setTimeout(function () { showVariantImage(document); }, 0);
  });
  /* ?aantal=2 vanaf de homepage: kies meteen de duo-optie */
  try {
    var n = new URLSearchParams(location.search).get('aantal');
    if (n) {
      var r = document.querySelector('[data-kl-offer] input[name="quantity"][value="' + n.replace(/\D/g, '') + '"]');
      if (r) r.checked = true;
    }
  } catch (e) {}
})();
